export default __webpack_public_path__ + "static/media/9.ca64c87e.jpg";